/**
 * Built-in lists and the views this person has saved.
 */

import React, { useState } from 'react';

export default function SavedViews({ pack, onApply, onSave, onDelete, busy }) {
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState('');
  const presets = pack?.presets || [];
  const views = pack?.views || [];

  function choose(event) {
    const id = event.target.value;
    event.target.value = '';
    if (!id) return;
    const preset = presets.find((view) => view.id === id);
    const saved = views.find((view) => view.id === id);
    if (preset || saved) onApply(preset || saved);
  }

  function save(event) {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
    setName('');
    setNaming(false);
  }

  return (
    <div className="support-views">
      <label className="rf-label" htmlFor="support-views">
        Views
        <select id="support-views" className="rf-input" defaultValue="" onChange={choose}>
          <option value="">Choose a view</option>
          <optgroup label="Built in">
            {presets.map((view) => <option key={view.id} value={view.id}>{view.name}</option>)}
          </optgroup>
          {views.length > 0 && (
            <optgroup label="Saved">
              {views.map((view) => <option key={view.id} value={view.id}>{view.name}</option>)}
            </optgroup>
          )}
        </select>
      </label>
      {naming ? (
        <form className="support-view-save" onSubmit={save}>
          <input
            className="rf-input"
            aria-label="View name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            maxLength={60}
            required
          />
          <button type="submit" className="rf-btn rf-btn-secondary" disabled={busy}>Save</button>
          <button type="button" className="rf-btn rf-btn-ghost" onClick={() => setNaming(false)}>Cancel</button>
        </form>
      ) : (
        <button type="button" className="rf-btn rf-btn-outline" onClick={() => setNaming(true)}>Save this view</button>
      )}
      {views.length > 0 && (
        <label className="rf-label" htmlFor="support-view-delete">
          Remove a saved view
          <select
            id="support-view-delete"
            className="rf-input"
            defaultValue=""
            onChange={(event) => {
              const id = event.target.value;
              event.target.value = '';
              if (id) onDelete(id);
            }}
          >
            <option value="">Keep all</option>
            {views.map((view) => <option key={view.id} value={view.id}>{view.name}</option>)}
          </select>
        </label>
      )}
    </div>
  );
}
